module.exports = __webpack_public_path__ + "media/images/webpage/inquiries/address-press-b59348b4856a0f74378e2416bbe4ff7a.svg";